import { render, staticRenderFns } from "./PinkPagination.vue?vue&type=template&id=fe292de2&scoped=true&"
import script from "./PinkPagination.vue?vue&type=script&lang=js&"
export * from "./PinkPagination.vue?vue&type=script&lang=js&"
import style0 from "./PinkPagination.vue?vue&type=style&index=0&id=fe292de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe292de2",
  null
  
)

export default component.exports